export type DocumentParentType = 'tenant' | 'site' | 'customer' | 'product' | 'manufacturer-product' | 'visit';

export const operationalDocumentCategories = [
    'RAMS',
    'Scope of Works',
    'Certificate',
    'Policy',
    'Health & Safety',
    'Survey / Inspection',
    'Permit / Pre-start',
    'Report',
    'Other',
] as const;

export interface OperationalDocument
{
    id: string;
    documentable_type: DocumentParentType;
    documentable_id: string;
    category: string | null;
    title: string | null;
    file_name: string;
    content_type: string | null;
    size: number | null;
    checksum: string | null;
    status: 'pending_upload' | 'available' | string;
    visible_to_customer: boolean;
    visible_on_app: boolean;
    include_in_report: boolean;
    author_id: number | null;
    author?: { id: number; name: string } | null;
    created_at: string | null;
    updated_at: string | null;
}

export interface DocumentUploadIntent
{
    document: OperationalDocument;
    upload_url: string;
    expires_at: string;
}

export interface DocumentIntentPayload
{
    documentable_type: DocumentParentType;
    documentable_id: string;
    category: string;
    title?: string;
    file_name: string;
    content_type: string;
    size: number;
    checksum: string;
    visible_to_customer?: boolean;
    visible_on_app?: boolean;
    include_in_report?: boolean;
}

export interface DocumentStorageUsage {
    used_bytes: number;
    reserved_bytes: number;
    limit_bytes: number | null;
    remaining_bytes: number | null;
    over_limit: boolean;
    ready: boolean;
    enforced: boolean;
}
